import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import MenuDoctor from "./navDoctor/MenuDoctor";
import { useLocation, useNavigate } from "react-router-dom";
import * as medicalApi from "../../service/medicalApi";
import { HashLoader } from "react-spinners";
import moment from "moment";
import "moment/locale/th";
import NotfoundUi from "../notfound/NotfoundUi";
import { RedirectCode400 } from "../RedirectCode400";
import Select from "../material/select/Select";
import ModalLaboratoryResult from "../material/modal/ModalLaboratoryResult";
import icon__labresult from "../../asset/icon/labresult.svg";
import icon__analysis__result from "../../asset/icon/analysisResultLab.svg";

import { CurrentUserContext } from "../../App";

function PermisstionLabPatient() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [credentialToken, setCredentialToken] = useState(null);
  const [patient, setPatient] = useState(null);

  const [LabList, setLabList] = useState([]);
  const [LabList_Storage, setLabList_Storage] = useState([]);

  const [name, setName] = useState("");
  const [pid, setPid] = useState("");
  const [age, setAge] = useState("");
  const [birthday, setBirthday] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const [valueSelectGene, setValueSelectGene] = useState("");
  const [selectTypeGene, setSelectTypeGene] = useState([
    {
      key: "",
      value: "ยีนทั้งหมด",
    },
    {
      key: "allergy",
      value: "ยีนแพ้ยา",
    },
    {
      key: "degrading",
      value: "ยีนย่อยสลายยา",
    },
  ]);

  const [openModal, setOpenModal] = useState(false);

  const [valueSelectResultGene, setValueSelectResultGene] = useState("");
  const [selectResultName, setSelectResultName] = useState([]);

  useEffect(() => {
    if (location.state?.["credential_token"] === undefined) {
      navigate("/dataAccessRights");
    } else {
      setCredentialToken(location.state?.["credential_token"]);
    }
  }, []);

  useEffect(() => {
    if (valueSelectGene === "allergy") {
      setValueSelectResultGene("HLA-B*58:01");
      setSelectResultName([
        { key: "HLA-B*58:01", value: "HLA-B*58:01" },
        { key: "HLA-B*57:01", value: "HLA-B*57:01" },
        { key: "HLA-B*15:02", value: "HLA-B*15:02" },
      ]);
    } else if (valueSelectGene === "degrading") {
      setValueSelectResultGene("NAT2-diplotype");
      setSelectResultName([{ key: "NAT2-diplotype", value: "NAT2-diplotype" }]);
    } else {
      setValueSelectResultGene("");
    }
  }, [valueSelectGene, credentialToken]);

  useEffect(() => {
    getLabInformation();
  }, [credentialToken]);

  useEffect(() => {
    if (patient) {
      setName(patient["pname"] + patient["fname"] + " " + patient["lname"]);
      setPid(patient["pid"]);
      setAge(moment().diff(moment(patient["birthday"], ["DD/MM/YYYY", "YYYY-MM-DD"]), "years"));
      setBirthday(
        moment(patient["birthday"], ["DD/MM/YYYY", "YYYY-MM-DD"]).add(543, "years").format("D MMMM YYYY"),
      );
      setPhoneNumber(patient["phone_number"]);
      setEmail(patient["email"]);
    } else {
      setName("");
      setPid("");
      setAge("");
      setBirthday("");
      setPhoneNumber("");
      setEmail("");
    }
  }, [patient]);

  const PresetTailwind = {
    HardText: "text-[#526F65] text-[18px] font-semibold",
    SoftText: "text-[#526F65] text-[16px] font-medium",
    HardSubText: "text-[#000000] text-[18px] font-semibold",
  };

  const getLabInformation = async () => {
    if (!credentialToken) {
      return;
    }
    setLoading(true);
    let res = await medicalApi.getLabInformation(credentialToken);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        let labList = res["data"]["lab_list"];
        labList = labList.map((item, index) => {
          item["note"] = "";

          if (item["expr2"].includes("HLA-B*15:02")) {
            if (
              item.lab_classify?.lab_result?.result?.result_key === "positive"
            ) {
              item["note"] =
                `จากการศึกษาที่ผ่านมาพบว่า คนไทยร้อยละ 17.5 (7/40) ไม่เป็น SJS/ TEN จากการใช้ carbamazepine ทั้งที่มี HLA-B*15:02
              (Kulkantrakorn et. al., 2012)`;
            } else if (
              item.lab_classify?.lab_result?.result?.result_key === "negative"
            ) {
              item["note"] =
                `จากการศึกษาที่ผ่านมาพบว่าร้อยละ 11 (5/42) ของคนไทยที่เป็น SJS/TEN จาก carbamazepine ไม่มี HLA-B*15:02
              (Tassaneeyakul et. al., 2010)`;
            }
          }

          if (item["expr2"].includes("HLA-B*58:01")) {
            if (
              item.lab_classify?.lab_result?.result?.result_key === "positive"
            ) {
              item["note"] =
                `จากการศึกษาที่ผ่านมาพบว่า คนไทยที่เป็น SJS/TEN จากการใช้ allopurinol ทั้ง 27 คน มี HLA-B*58:01 ทุกคน ถึงแม้จะพบว่า
              มีร้อยละ 13 (7/54) ของคนไทยไม่ได้เป็น SJS/TEN จากการใช้ allopurinol ทั้งที่มี HLA-B*58:01 (Tassaneeyakul et. al., 2009)`;
            } else if (
              item.lab_classify?.lab_result?.result?.result_key === "negative"
            ) {
              item["note"] =
                `จากการศึกษาที่ผ่านมาพบว่าผู้ป่วยที่มี HLA-B*58:01 มีความเสี่ยงที่จะเป็น SJS/TEN น้อยกว่ากลุ่ม HLA-B*58:01-Positive
              ถึง 348.3 เท่า (Tassaneeyakul et. al., 2009)`;
            }
          }
          return item;
        });

        setLabList(labList);
        setLabList_Storage(labList);
        setPatient(res["data"]["patient"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else if (res["data"]["code"] === 408) {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/dataAccessRights");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const DisplayStylesButton = (testing_result_type) => {
    if (testing_result_type === "negative") {
      return "flex items-center justify-center bg-gradient-to-r from-[#E9DA52] to-[#EFF198] w-44 h-9 rounded-3xl #EFF198 text-[#575757]";
    } else if (testing_result_type === "positive") {
      return "flex items-center justify-center bg-gradient-to-r from-[#9E1818] to-[#F19898] w-44 h-9 rounded-3xl #F19898 text-[#ffffff]";
    } else if (testing_result_type === "slow_acetylator") {
      return "flex items-center justify-center bg-gradient-to-r from-[#9E1818] to-[#F19898] w-44 h-9 rounded-3xl #F19898 text-[#ffffff]";
    } else if (testing_result_type === "intermediate_acetylator") {
      return "flex items-center justify-center bg-gradient-to-r from-[#CB724A] to-[#FFBA9B] w-44 h-9 rounded-3xl #FFBA9B text-[#575757]";
    } else if (testing_result_type === "rapid_acetylator") {
      return "flex items-center justify-center bg-gradient-to-r from-[#24A1B3] to-[#ACF0FF] w-44 h-9 rounded-3xl #ACF0FF text-[#575757]";
    }
  };

  function urlify(text) {
    let urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, function (url) {
      let hyperlink = url;
      if (!hyperlink.match("^https?:\/\/")) {
        hyperlink = "http://" + hyperlink;
      }
      return (
        '<a className="blue" href="' + url + '" target="_blank">' + url + "</a>"
      );
    });
  }

  const onChangeSelectResultGene = (e) => {
    setValueSelectResultGene(e);
  };

  const onclickOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <div>
      {openModal && LabList.length > 0 ? (
        <>
          <ModalLaboratoryResult
            data={LabList}
            onClose={() => {
              setOpenModal(false);
            }}
          />
        </>
      ) : null}
      <div className="mt-10">
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
        >
          ข้อมูลการตรวจยีน
        </div>
        <div className=" w-full flex flex-col ring-1 ring-[#A2B5BC] p-7 rounded-lg">
          <div className="flex lg:flex-col md:justify-center gap-8 w-full">
            <div className="lg:flex lg:justify-center">
              <img
                className="h-20 w-20"
                src={
                  require("../../asset/icon/profile-icon-orange.svg").default
                }
                alt="iconuser"
              />
            </div>
            <div className="grid grid-cols-3 lg:flex flex-col gap-4 items-center w-full">
              <div className="flex gap-2">
                <p className={PresetTailwind.HardText}>{name}</p>
              </div>
              <div className="flex gap-5 xl:gap-2">
                <p className={PresetTailwind.HardText}>เลขบัตรประชาชน</p>
                <p className={PresetTailwind.HardSubText}>{pid}</p>
              </div>
              <div className="flex gap-8 ml-12 lg:ml-0">
                <p className={PresetTailwind.HardText}>อายุ</p>
                <p className={PresetTailwind.HardSubText}>{age}</p>
                <p className={PresetTailwind.HardText}>ปี</p>
              </div>
              <div className="flex gap-8">
                <p className={PresetTailwind.HardText}>วันเกิด</p>
                <p className={PresetTailwind.HardSubText}>{birthday}</p>
              </div>
              <div className="flex gap-4">
                <p className={PresetTailwind.HardText}>อีเมล</p>
                <p className={PresetTailwind.HardSubText}>{email}</p>
              </div>
              <div className="flex gap-3 ml-12 lg:ml-0">
                <p className={PresetTailwind.HardText}>เบอร์โทร</p>
                <p className={PresetTailwind.HardSubText}>{phoneNumber}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-end mt-10">
          {/* <img onClick={onclickOpenModal} className='w-[42px] h-[42px] cursor-pointer' src={icon__labresult} alt='' /> */}
          <div
            onClick={onclickOpenModal}
            className="mt-[15px] button-theme-pg font-[600] flex items-center justify-center gap-4 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] w-52 h-12 rounded-3xl #EFF198 text-[#575757]"
          >
            <img src={icon__analysis__result} />
            <div>สรุปผลการตรวจ</div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center">
        <div className="grid grid-cols-3 md:grid-cols-1 gap-10 md:w-full lg:w-11/12 xl:w-11/12 2xl:w-9/12 w-8/12">
          {/* <Select
            label={'ประเภทของยีน'}
            placeholder={'เลือกประเภทของยีน'}
            list={selectTypeGene}
            value={valueSelectGene}
            setValue={setValueSelectGene}
          />
          <Select
            label={'ชื่อผลการตรวจ'}
            placeholder={'เลือกชื่อผลการตรวจ'}
            list={selectResultName}
            value={valueSelectResultGene}
            disabled={valueSelectGene !== '' ? false : true}
            setValue={(e) => { onChangeSelectResultGene(e) }}
          /> */}

          <div></div>
        </div>
      </div>

      {!loading ? (
        <>
          {LabList.filter((item) => {
            return item["expr2"].includes(valueSelectResultGene);
          }).length > 0 ? (
            <>
              {LabList.filter((item) => {
                return item["expr2"].includes(valueSelectResultGene);
              }).map((i, idx) => {
                return (
                  <div
                    key={idx}
                    className={`w-full flex justify-center mt-10 mb-10`}
                  >
                    <div className="xl:w-11/12 2xl:w-9/12 w-8/12 flex flex-col ring-1 ring-[#A2B5BC] p-7 rounded-lg">
                      <div className="flex justify-between md:grid md:grid-cols-1 md:gap-y-2 border-b border-[#A6DFCF] pb-3">
                        <div className="grid grid-cols-1 gap-y-2">
                          <p
                            className={`underline underline-offset-4 text-[20px] ${PresetTailwind.HardText}`}
                          >
                            {i["testing_group"]}
                          </p>
                          <p
                            className={`text-[20px] ${PresetTailwind.HardText}`}
                          >
                            {i["customer_name"]}
                          </p>
                          <p className="text-[14px] text-[#000000] font-semibold">
                            {moment(i["last_save"]?.["timestamp"])
                              .add(543, "years")
                              .format("DD MMMM YYYY") +
                              " " +
                              "เวลา" +
                              " " +
                              i["last_save"]?.["time"] +
                              " น."}
                          </p>
                        </div>
                        <div>
                          <div
                            className={`font-medium ${DisplayStylesButton(
                              i["lab_classify"]["lab_result"]["result"][
                                "result_key"
                              ],
                            )}`}
                          >
                            {/* {i['lab_classify']['lab_result']['result']['result_key']?.charAt(0).toUpperCase() + i['lab_classify']['lab_result']['result']['result_key']?.slice(1)} */}
                            {
                              i["lab_classify"]["lab_result"]["result"][
                                "result_name"
                              ]
                            }
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-y-5 mt-8">
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            ชื่อการตรวจ
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>{i["expr2"]}</p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            วัตถุประสงค์
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>{i["lab_classify"]["lab_result"]["objective"]}</p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            หน่วยงานที่ส่งตรวจ
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>{i["customer_name"]}</p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            วันที่เก็บตัวอย่าง
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>
                            {moment(i["collect_date"])
                              .add(543, "years")
                              .format("DD MMMM YYYY")}
                          </p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            วันที่ตรวจ
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>
                            {moment(i["report_date"])
                              .add(543, "years")
                              .format("DD MMMM YYYY")}
                          </p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            ห้องปฏิบัติการ
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>{i["testing_no"]}</p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            หมายเลขผู้ป่วยนอก
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>{i["hn"] || "-"}</p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            ผลการวิเคราะห์
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>{i["testing_result"]}</p>
                        </div>
                        <div className="flex justify-end pr-4 sm:justify-start sm:col-span-3">
                          <p className={`${PresetTailwind.SoftText}`}>
                            การแปลผล
                          </p>
                        </div>
                        <div className="col-span-2 pl-20 text-[#2E2E2E] font-semibold sm:pl-0 sm:col-span-3">
                          <p>
                            {
                              i["lab_classify"]["lab_result"]["result"][
                                "interpretation"
                              ]
                            }
                          </p>
                        </div>
                      </div>
                      <div className="w-full flex justify-center">
                        <div className="w-3/4">
                          <p className="mt-8 text-[#2E2E2E] font-semibold">
                            ข้อมูลจากระบบ iLABplus หมายเลขตัวอย่าง{" "}
                            {i["testing_no"]} เลขที่รายงานผล{" "}
                            {i["report_no"] ? i["report_no"] : "-"}{" "}
                            วันที่ออกรายงานผล{" "}
                            {moment(i["report_date"])
                              .add(543, "years")
                              .format("D MMMM YYYY")}
                          </p>
                          {i["lab_classify"]["lab_result"]["result"][
                            "recommend_doctor"
                          ]?.length > 0 ? (
                            <>
                              <p className="mt-8 font-semibold border-b border-[#B9DFC5] pb-4">
                                คำแนะนำ
                              </p>
                              {i["lab_classify"]["lab_result"]["result"][
                                "recommend_doctor"
                              ].map((recommend, index) => {
                                return (
                                  <>
                                    <div className="flex justify-start gap-x-6">
                                      <p className="mt-4">{index + 1}.</p>
                                      <p
                                        className="mt-4"
                                        dangerouslySetInnerHTML={{
                                          __html: urlify(recommend),
                                        }}
                                      />
                                    </div>
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            <div className="my-2">ไม่มีคำแนะนำ</div>
                          )}
                          {i["note"] ? (
                            <>
                              <p className="mt-8 text-base font-semibold border-b border-[#B9DFC5] pb-4">
                                หมายเหตุ
                              </p>
                              <div className="flex justify-start gap-x-6">
                                <p className="mt-4"> {i["note"]}</p>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <NotfoundUi title={"ไม่พบข้อมูล"} />
          )}
        </>
      ) : (
        <HashLoader
          disabled
          loading={loading}
          style={{ display: "flex", justifyContent: "center" }}
          color="#FF9768"
        />
      )}
    </div>
  );
}

export default PermisstionLabPatient;
